import {
  Box,
  Button,
  Checkbox,
  Drawer,
  Flex,
  Grid,
  Select,
  Text,
  Textarea,
  TextInput,
} from "@mantine/core";
import { GoChevronDown } from "react-icons/go";
import { useForm } from "@mantine/form";
import { stateZipCodes } from "../../utils/zipCodes";
import { DatePickerInput } from "@mantine/dates";
import useStyles from "./style";
import { FiCalendar } from "react-icons/fi";
import { useEffect, useState } from "react";
import {
  addSkypointProspect,
  updateSkypointProspect,
} from "../../services/skypointProspect";
import { useSelector } from "react-redux";
import moment from "moment";
import { addSkypointProvider } from "../../services/skypointProvider";

const AddProspectDrawer = ({
  drawerOpen,
  drawerClose,
  callGetProspectWithFiltersCount,
  mode,
  data,
}) => {
  const { classes } = useStyles();
  const [btnLoading, setBtnLoading] = useState(false);
  const isViewMode = mode === "view";
  const { profile } = useSelector((state) => state?.profile);

  const {
    skypointProviders,
    skypointProvidersCount,
    skypointProvidersLoading,
  } = useSelector((state) => state?.skypointProviders);

  const form = useForm({
    initialValues: {
      firstName: "",
      lastName: "",
      contactFirstName: "",
      contactLastName: "",
      phone: null,
      email: "",
      address: "",
      city: "",
      state: "",
      zipcode: "",
      date: undefined,
      amount: 0,
      note: "",
      services: [],
    },
    validate: {
      firstName: (value) => (value?.trim() ? null : "Required"),
      lastName: (value) => (value?.trim() ? null : "Required"),
      contactFirstName: (value) => (value?.trim() ? null : "Required"),
      contactLastName: (value) => (value?.trim() ? null : "Required"),
      phone: (value) => (value ? null : "Required"),
      email: (value) => (value?.trim() ? null : "Required"),
      address: (value) => (value?.trim() ? null : "Required"),
      city: (value) => (value?.trim() ? null : "Required"),
      state: (value) => (value?.trim() ? null : "Required"),
      zipcode: (value) => (value?.trim() ? null : "Required"),
      date: (value) => (value ? null : "Required"),
      amount: (value) => (value ? null : "Required"),
      note: (value) => (value?.trim() ? null : "Required"),
      services: (value) => (value?.length > 0 ? null : "Select at least one"),
    },
  });

  useEffect(() => {
    if (data) {
      form.setValues({
        // provider: data?.provider?._id,
        firstName: data?.firstName || "",
        lastName: data?.lastName || "",
        contactFirstName: data?.contactFirstName,
        contactLastName: data?.contactFirstName,
        phone: data?.phone,
        email: data?.email,
        address: data?.address,
        city: data?.city,
        state: data?.state,
        zipcode: data?.zipcode,
        date: moment(data?.date),
        amount: data?.amount,
        note: data?.note,
        services: data?.services,
      });
    }
  }, [data]);

  const handleDrawerClose = () => {
    form.reset();
    drawerClose();
  };

  const handleSubmit = async (values) => {
    console.log("🚀 ~ handleSubmit ~ values:", values);
    try {
      setBtnLoading(true);
      if (mode === "add") {
        const payload = {
          ...values,
          name: `${form?.values?.firstName} ${form?.values?.lastName}`.trim(),
          adminType: "skypointAdmin",
          platform: "ogiso",
          amount: Number(values?.amount),
        };
        // const res = await addSkypointProspect(
        const res = await addSkypointProspect(
          payload,
          callGetProspectWithFiltersCount
        );
        res && handleDrawerClose();
      } else if (mode === "edit") {
        const payload = {
          id: data?._id,
          ...values,
          amount: Number(values?.amount),
        };
        const res = await updateSkypointProspect(
          payload,
          callGetProspectWithFiltersCount
        );
        res && handleDrawerClose();
      }
    } catch (error) {
      console.log("🚀 ~ handleSubmit ~ error:", error);
      setBtnLoading(false);
    } finally {
      setBtnLoading(false);
    }
  };
  return (
    <>
      <Drawer
        opened={drawerOpen}
        offset={8}
        size="55%"
        sx={{
          ".mantine-Drawer-close": {
            color: "#000",
            "& svg": {
              width: "25px !important",
              height: "25px !important",
            },
          },
          ".mantine-11shxvp": {
            background: "#F5F5F5",
            borderTopLeftRadius: 16,
            borderBottomLeftRadius: 16,
          },
          ".mantine-Drawer-close:hover": {
            color: "#FFAF4A",
          },
          ".mantine-1q36a81": {
            padding: "0",
          },
        }}
        zIndex={1000}
        title={
          <Text fz={24} fw={700} ff="Inter" color="#000">
            {mode === "view"
              ? "View Prospect"
              : mode === "edit"
              ? "Edit Prospect"
              : "New Prospect"}
          </Text>
        }
        position="right"
        overlayProps={{ backgroundOpacity: 2.5, blur: 4 }}
        shadow="md"
        onClose={handleDrawerClose}
        centered
      >
        <Flex direction="column" align="flex-end" py={14} px={18}>
          <form onSubmit={form.onSubmit((values) => handleSubmit(values))}>
            <Box className={classes.formBox}>
              <Grid gutter={16}>
                <Grid.Col span={6}>
                  <TextInput
                    label="Provider First Name"
                    placeholder="Enter provider first name"
                    clearable
                    className={classes.inputField}
                    disabled={isViewMode}
                    {...form.getInputProps("firstName")}
                  />
                </Grid.Col>
                <Grid.Col span={6}>
                  <TextInput
                    label="Provider Lasr Name"
                    placeholder="Enter provider last name"
                    clearable
                    className={classes.inputField}
                    disabled={isViewMode}
                    {...form.getInputProps("lastName")}
                  />
                </Grid.Col>
                <Grid.Col span={6}>
                  <TextInput
                    className={classes.inputField}
                    label="Contact First Name"
                    placeholder="Enter contact first name"
                    disabled={isViewMode}
                    {...form.getInputProps("contactFirstName")}
                  />
                </Grid.Col>
                <Grid.Col span={6}>
                  <TextInput
                    className={classes.inputField}
                    label="Contact Last Name"
                    placeholder="Enter contact last name"
                    disabled={isViewMode}
                    {...form.getInputProps("contactLastName")}
                  />
                </Grid.Col>
                <Grid.Col span={6}>
                  <TextInput
                    className={classes.inputField}
                    label="Phone #"
                    placeholder="Enter phone"
                    type="number"
                    disabled={isViewMode}
                    {...form.getInputProps("phone")}
                  />
                </Grid.Col>
                <Grid.Col span={6}>
                  <TextInput
                    className={classes.inputField}
                    label="Email Address"
                    placeholder="Enter email address"
                    disabled={isViewMode}
                    {...form.getInputProps("email")}
                  />
                </Grid.Col>
                <Grid.Col span={12}>
                  <TextInput
                    className={classes.inputField}
                    label="Address"
                    placeholder="Enter address"
                    disabled={isViewMode}
                    {...form.getInputProps("address")}
                  />
                </Grid.Col>
                <Grid.Col span={4}>
                  <TextInput
                    className={classes.inputField}
                    label="City"
                    placeholder="Enter city"
                    disabled={isViewMode}
                    {...form.getInputProps("city")}
                  />
                </Grid.Col>
                <Grid.Col span={4}>
                  <Select
                    label="State"
                    placeholder="Select state"
                    data={Array.from(
                      new Set(stateZipCodes?.map((obj) => obj.ste_name))
                    )
                      .sort()
                      .map((ste_name) => ({
                        value: ste_name,
                        label: ste_name,
                      }))}
                    clearable
                    rightSection={<GoChevronDown color="#94A3B8" size={18} />}
                    className={classes.inputField}
                    disabled={isViewMode}
                    {...form.getInputProps("state")}
                  />
                </Grid.Col>
                <Grid.Col span={4}>
                  <TextInput
                    className={classes.inputField}
                    label="Zipcode"
                    placeholder="Enter zipcode"
                    disabled={isViewMode}
                    {...form.getInputProps("zipcode")}
                  />
                </Grid.Col>
                <Grid.Col span={6}>
                  <DatePickerInput
                    label="Date"
                    placeholder="Pick Date"
                    className={classes.datePickerInput}
                    icon={<FiCalendar color="#262626" size={18} />}
                    disabled={isViewMode}
                    {...form.getInputProps("date")}
                  />
                </Grid.Col>
                <Grid.Col span={6}>
                  <TextInput
                    className={classes.inputField}
                    label="Amount"
                    placeholder="Enter Amount"
                    type="number"
                    disabled={isViewMode}
                    {...form.getInputProps("amount")}
                  />
                </Grid.Col>
                <Grid.Col span={12}>
                  <Box className={classes.servicesSection}>
                    <Text className="hdng">Services</Text>
                    <Box className="grayBox">
                      <Box className="services">
                        <p className="label">Select all that applies</p>
                        <Flex className="servicesParent">
                          {[
                            "QDDP",
                            "Care Plan",
                            "Billing",
                            "Quarterly",
                            "Accounting",
                            "IT",
                          ].map((item) => (
                            <Checkbox
                              key={item}
                              label={item}
                              value={item}
                              disabled={isViewMode}
                              checked={form.values.services.includes(item)}
                              onChange={(e) => {
                                const checked = e.target.checked;
                                if (checked) {
                                  form.setFieldValue("services", [
                                    ...form.values.services,
                                    item,
                                  ]);
                                } else {
                                  form.setFieldValue(
                                    "services",
                                    form.values.services.filter(
                                      (v) => v !== item
                                    )
                                  );
                                }
                              }}
                            />
                          ))}
                        </Flex>
                        {form.errors.services && (
                          <Text fz={12} mt={2} color="red">
                            {form.errors.services}
                          </Text>
                        )}
                      </Box>
                      <Textarea
                        label="Note"
                        placeholder="Enter invoice note"
                        className={classes.noteTextArea}
                        disabled={isViewMode}
                        {...form.getInputProps("note")}
                      />
                    </Box>
                  </Box>
                </Grid.Col>
              </Grid>
              {!isViewMode && (
                <Flex className={classes.actionsRow}>
                  <Button
                    className={classes.cancelBtn}
                    onClick={handleDrawerClose}
                  >
                    Cancel
                  </Button>
                  <Button
                    loading={btnLoading}
                    type="submit"
                    className={classes.saveBtn}
                  >
                    {mode === "edit" ? "Update" : "Save"}
                  </Button>
                </Flex>
              )}
            </Box>
          </form>
        </Flex>
      </Drawer>
    </>
  );
};

export default AddProspectDrawer;
